import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface StudentIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const StudentIcon = ({ className, ...props }: StudentIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.9375 13.1003C20.7552 13.1003 20.5803 13.0279 20.4514 12.8989C20.3224 12.77 20.25 12.5951 20.25 12.4128V8.97531C20.25 8.79297 20.3224 8.61811 20.4514 8.48917C20.5803 8.36024 20.7552 8.28781 20.9375 8.28781C21.1198 8.28781 21.2947 8.36024 21.4236 8.48917C21.5526 8.61811 21.625 8.79297 21.625 8.97531V12.4128C21.625 12.5951 21.5526 12.77 21.4236 12.8989C21.2947 13.0279 21.1198 13.1003 20.9375 13.1003Z"
      fill="currentColor"
    />
    <path
      d="M12.077 12.2753C11.6301 12.2753 11.2424 12.2148 10.8546 12.0828L2.05875 8.73194C1.13612 8.35519 1 7.77493 1 7.46281C1 7.14931 1.13612 6.56906 2.04362 6.19918L10.7529 2.85244C11.4239 2.59256 12.5734 2.59119 13.2485 2.85244L21.9426 6.19369C22.8639 6.56769 23 7.14931 23 7.46281C23 7.77631 22.8639 8.35518 21.955 8.72643L13.2471 12.0732C12.9611 12.2038 12.5665 12.2753 12.077 12.2753ZM2.58812 7.46281L11.3208 10.7876C11.5449 10.8646 11.7772 10.9003 12.077 10.9003C12.4317 10.9003 12.6215 10.8481 12.7164 10.8054L21.4105 7.46281L12.7535 4.13669C12.3933 3.99644 11.604 3.99781 11.2479 4.13669L2.58812 7.46281Z"
      fill="currentColor"
    />
    <path
      d="M12.0769 14.8397C11.6314 14.8397 11.2437 14.7778 10.8545 14.6458L4.87054 12.3688L5.35867 11.0832L11.3193 13.3533C11.5448 13.4289 11.7772 13.4661 12.0755 13.4661C12.4289 13.4661 12.6187 13.4138 12.7149 13.3698L18.626 11.0969L19.1197 12.3812L13.247 14.6376C12.9597 14.7696 12.565 14.8397 12.0769 14.8397Z"
      fill="currentColor"
    />
    <path
      d="M12.0742 21.3503C8.53362 21.3503 4.63413 20.2682 4.44025 17.8908L4.4375 11.7253C4.4375 11.5429 4.50993 11.3681 4.63886 11.2391C4.7678 11.1102 4.94266 11.0378 5.125 11.0378C5.30734 11.0378 5.4822 11.1102 5.61114 11.2391C5.74007 11.3681 5.8125 11.5429 5.8125 11.7253V17.7629C5.90737 18.9688 8.77562 19.9753 12.0742 19.9753C14.6689 19.9753 17.0655 19.3662 17.9029 18.4944C18.1036 18.2868 18.1957 18.0792 18.1861 17.8633V11.7748C18.1861 11.5924 18.2586 11.4176 18.3875 11.2886C18.5164 11.1597 18.6913 11.0873 18.8736 11.0873C19.056 11.0873 19.2308 11.1597 19.3598 11.2886C19.4887 11.4176 19.5611 11.5924 19.5611 11.7748V17.7629C19.5859 18.3995 19.3549 18.966 18.8956 19.4459C17.5468 20.8498 14.4887 21.3503 12.0742 21.3503Z"
      fill="currentColor"
    />
    <path
      d="M20.25 14.4753C20.25 14.6576 20.3224 14.8325 20.4514 14.9614C20.5803 15.0903 20.7552 15.1628 20.9375 15.1628C21.1198 15.1628 21.2947 15.0903 21.4236 14.9614C21.5526 14.8325 21.625 14.6576 21.625 14.4753C21.625 14.2929 21.5526 14.1181 21.4236 13.9891C21.2947 13.8602 21.1198 13.7878 20.9375 13.7878C20.7552 13.7878 20.5803 13.8602 20.4514 13.9891C20.3224 14.1181 20.25 14.2929 20.25 14.4753Z"
      fill="currentColor"
    />
  </svg>
);

export default StudentIcon;
